module.exports = __webpack_public_path__ + "img/dropdown-arrow-dark.c4bb3ace.svg";